const Permissions = {
    CanAll: '*',

    UI: {
        CanListTasks: 'ui.tasks.list',
        CanListNumerics: 'ui.numerics.list',
    },

    Tasks: {
        CanCreate: 'tasks.create',
        CanUpdate: 'tasks.update',
        CanDelete: 'tasks.delete',
        CanComment: 'tasks.comment',
        CanComplete: 'tasks.complete',
    },

    Goals: {
        CanCreate: 'goals.create',
        CanUpdate: 'goals.update',
        CanDelete: 'goals.delete',
        CanComment: 'goals.comment',
        CanComplete: 'goals.complete',
    },

    Columns: {
        CanCreate: 'columns.create',
        CanUpdate: 'columns.update',
        CanDelete: 'columns.delete',
    },

    TaskManagement: {
        CanRead: 'task-management.read',
        CanReadStatistic: 'task-management.read.statistic',
    },

    Numerics: {
        CanRead: 'numerics.read',
        CanCreate: 'numerics.create',
        CanDelete: 'numerics.delete',
        CanUpdatePublicFields: 'numerics.update:public-fields',
        CanUpdatePrivateFields: 'numerics.update:private-fields',
    },

    NumericCounters: {
        CanRead: 'numeric-counters.read',
        CanCreate: 'numeric-counters.create',
        CanDelete: 'numeric-counters.delete',
        CanUpdatePublicFields: 'numeric-counters.update:public-fields',
        CanUpdatePrivateFields: 'numeric-counters.update:private-fields',
    },

    NumericCounterValues: {
        CanRead: 'numeric-counter-values.read',
        CanCreate: 'numeric-counter-values.create',
    },
};

export default Permissions;
